import { Controller } from "stimulus"
import $ from 'jquery';

export default class extends Controller {
  static targets = ['content', 'photo']

  setPhoto() {
    const file = this.photoTarget.files[0]

    if (file) {
      const content = this.contentTarget
      const reader = new FileReader()

      reader.onloadend = () => {
        $(content).css("background-image", `url("${reader.result}")`)
      }
      reader.readAsDataURL(file)
    }
  }
}